module.exports = __webpack_public_path__ + "img/american-violence-2.c248e18b.png";